export const hasTokenPermissions = (token: string): boolean => {
    const parsed = parseJwtToken<AccessTokenPayload>(token)
    if (!parsed) return false
    return Object.keys(parsed.properties.permissions).length > 0
}

type AccessTokenPayload = {
    properties: {
        permissions: Record<string, unknown>
        [key: string]: unknown
    }
    exp: number
    [key: string]: unknown
}

const parseJwtToken = <T>(token: string): T | null => {
    try {
        const base64Url = token.split('.')[1]
        if (!base64Url) return null
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => (
            '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        )).join(''))
        return JSON.parse(jsonPayload) as T
    } catch {
        return null
    }
}
